/*
 * Old C&L
 */
$(document).ready(function () {
    if ($('.sticky-anchor-link').length) {
        var distance = $('.cl-find-block').offset().top - 200;
        var $window = $(window);
        $window.on('scroll', function () {    
            if($window.scrollTop() > 600 && $window.scrollTop() < distance) {
                $('.sticky-anchor-link').addClass('show');
            }
            else {
                $('.sticky-anchor-link').removeClass('show');
            }			
        });
    }

    $('.sticky-anchor-link').on('click', function(){
        var $self = $(this);
        $('html,body').animate({
            scrollTop: $('.cl-find-block').offset().top
        }, 500);
        setTimeout(function() {
            $self.removeClass('show');
            $('.cl-find-block #search').focus();
        }, 600);

        return false;
    })
});